import React from 'react'
import { useTranslation } from "react-i18next"
import { Dialog, DialogActionsBar  } from '@progress/kendo-react-dialogs'
import { Grid } from "@material-ui/core";
import './dialog-change-colab.css'

const DialogChangeAdminColabRol = (props) => {
  const { t } = useTranslation()
  return(
    <div>
      <Dialog title={t("modalChangeRolAdminColab.title")} width={480} height={350} onClose={props.closeDialog}>
        <Grid className="dialogChangeAdminColabRol-container"  container xs={12} lg={12} md={12} sm={12} es={12}>
          <p className="dialogChangeAdminColabRol-p-text">
            {t("modalChangeRolAdminColab.question")}
          </p>
        </Grid>
        <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
          <p className="dialogChangeAdminColabRol-p-text-advert">
            {t("modalChangeRolAdminColab.text.description")}
          </p>
        </Grid>
        <DialogActionsBar>
          <div className="dialogChangeAdminColabRol-container-buttons">
            <button
              className="dialogChangeAdminColabRol-button-cancel"
              onClick={props.closeDialog}
            >
              {props.canelBtn}
            </button>
            <button
              className="dialogChangeAdminColabRol-button-accept"
              onClick={props.acceptFn}
            >
              {props.acceptBtn}
            </button>
          </div>
        </DialogActionsBar>
      </Dialog>
    </div>
  )
}

export {DialogChangeAdminColabRol as default}